import React from "react";

export const ActionButton = ({ children }) => {
  return (
    <button className="action-button">
      {children}
      <style>{`
        .action-button {
          margin-top: 40px;
          padding: 15px 40px;
          background: linear-gradient(180deg, #f00 0%, #900 100%);
          color: #fff;
          font-family: Helvetica, -apple-system, Roboto, Helvetica, sans-serif;
          font-size: 18px;
          font-weight: 700;
          border: none;
          border-radius: 10px;
          cursor: pointer;
          transition: opacity 0.2s ease;
        }

        .action-button:hover {
          opacity: 0.9;
        }
      `}</style>
    </button>
  );
}; 